module.exports = __webpack_public_path__ + "img/advantages-icon3.1fe62a92.png";